import React, { lazy, Suspense } from 'react';
import { useParams, Navigate } from 'react-router-dom';

const labs = {
  // Grade 5-6
  fractions: lazy(() => import('./FractionsLab')),
  'lcm-hcf': lazy(() => import('./LCMHCFLab')),
  'simple-machines': lazy(() => import('./SimpleMachinesLab')),
  'human-body-basics': lazy(() => import('./HumanBodyBasicsLab')),
  // Grade 7-8
  'linear-equations': lazy(() => import('./LinearEquationsLab')),
  mensuration: lazy(() => import('./MensurationLab')),
  light: lazy(() => import('./LightLab')),
  motion: lazy(() => import('./MotionLab')),
  'cell-biology': lazy(() => import('./CellBiologyLab')),
  // Grade 9-10
  'quadratic-equations': lazy(() => import('./QuadraticEquationsLab')),
  trigonometry: lazy(() => import('./TrigonometryLab')),
  'coordinate-geometry': lazy(() => import('./CoordinateGeometryLab')),
  electricity: lazy(() => import('./ElectricityLab')),
  magnetism: lazy(() => import('./MagnetismLab')),
  'chemical-reactions': lazy(() => import('./ChemicalReactionsLab')),
  'periodic-table': lazy(() => import('./PeriodicTableLab')),
  genetics: lazy(() => import('./GeneticsLab')),
  // Grade 11-12
  calculus: lazy(() => import('./CalculusLab')),
  'vectors-3d': lazy(() => import('./Vectors3DLab')),
  electrodynamics: lazy(() => import('./ElectrodynamicsLab')),
  thermodynamics: lazy(() => import('./ThermodynamicsLab')),
  optics: lazy(() => import('./OpticsLab')),
  'organic-chemistry': lazy(() => import('./OrganicChemistryLab')),
  'chemical-bonding': lazy(() => import('./ChemicalBondingLab')),
  'geogebra': lazy(() => import('./GeoGebraLab')),
  // History (Nationalist & Military)
  revolutionaries: lazy(() => import('./RevolutionariesLab')),
  'shivaji-marathas': lazy(() => import('./ShivajiLab')),
  'post-independence-wars': lazy(() => import('./PostIndependenceLab')),
};

export default function VisualLabRouter() {
  const { labId } = useParams();
  const Lab = labs[labId];
  if (!Lab) return <Navigate to="/labs" replace />;
  return (
    <Suspense fallback={
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
          <span className="text-muted-foreground text-sm">Loading Lab...</span>
        </div>
      </div>
    }>
      <Lab />
    </Suspense>
  );
}
